@if (message) {
  <div class="modal" tabindex="-1" role="dialog" style="display:block!important">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        @if (message?.title) {
          <sb-modal-header
            [modalTitle]="message.title"
            (onClose)="message.cancel('close')"
          [headerClass]="message.isDanger ? 'danger' : null"></sb-modal-header>
        }
        @if (message?.type === 'confirm') {
          <div
            class="modal-body">
            <div [innerHTML]="message.text | translate: message.textTranslationParameters"></div>
            @if (message.checkBoxText) {
              <sb-check-box
                [(model)]="checkBoxValue"
              [label]="message.checkBoxText"></sb-check-box>
            }
            @if (message.warningText) {
              <div class="mt-4 alert alert-warning">{{message.warningText | translate }}
              </div>
            }
          </div>
        }
        <div class="modal-footer">
          @if (message.cancelButtonText !== '') {
            <sb-button buttonClass="warning"
              (onClick)="message.cancel('cancel')"
            [message]="message.cancelButtonText || 'SB_Cancel'"></sb-button>
          }
          <sb-button [buttonClass]="message.isDanger ? 'danger' : 'success'"
            (onClick)="message.confirm(checkBoxValue)"
          [message]="message.okButtonText || 'SB_OK'"></sb-button>
        </div>
      </div>
    </div>
  </div>
}
